export default "__VITE_ASSET__edfe0379__"